export const GET_MODULES = 'index/App/GET_MODULES';
export const GET_CATEGORIES = 'index/App/GET_CATEGORIES';
export const UPDATE_CURRENT_MODULE = 'index/App/UPDATE_CURRENT_MODULE';
export const UPDATE_CURRENT_CATEGORY = 'index/App/UPDATE_CURRENT_CATEGORY';
export const GET_FILTERED_CATEGORIES = 'index/App/GET_FILTERED_CATEGORIES';
export const UPDATE_FILTERED_CATEGORIES = 'index/App/UPDATE_FILTERED_CATEGORIES';
export const GET_ROUTES = 'index/App/GET_ROUTES';
export const UPDATE_SEARCH_MODE = 'index/App/UPDATE_SEARCH_MODE';
export const SET_AI_FEEDBACK_MODAL_VISIBLE = 'index/App/SET_FEEDBACK_MODAL_VISIBLE';
export const SET_AI_FEEDBACK_FORM_FILLED = 'index/App/SET_AI_FEEDBACK_FORM_FILLED';
export const SUBMIT_AI_FEEDBACK = 'index/App/SUBMIT_AI_FEEDBACK';
export const SET_CONTACT_MODAL_VISIBLE = 'index/App/SET_CONTACT_MODAL_VISIBLE';
export const SHOW_POLL_POPUP = 'index/App/SHOW_POLL_POPUP';
export const HIDE_POLL_POPUP = 'index/App/HIDE_POLL_POPUP';



// WEBPACK FOOTER //
// ./src/containers/App/constants.ts